import { AfterViewInit, Directive, Input, Renderer2, ElementRef } from '@angular/core';
import { GtagService } from './gtag.service';

@Directive({
    selector: '[gtagEvent]',
    standalone: false
})

export class GtagEventDirective implements AfterViewInit {
  @Input() trackOn: string = '';
  @Input() action: string = '';
  @Input() category: string = '';
  @Input() params: any;

  constructor(private gtag: GtagService, private renderer: Renderer2, private el: ElementRef) {
  }

  ngAfterViewInit() {
    try {
      this.renderer.listen(this.el.nativeElement, this.trackOn, () => {
        this.gtag.event(this.category, {
          event_category: this.action || this.trackOn,
          ...this.params
        })
      });
    } catch (err) {
      console.error(err);
    }
  }
}